import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './app/App';
import store from './redux/store';
import './app/i18n/index.ts';

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('app'),
);
